/* Gets initials for usage in things like image-less Avatars. Auth0 display name can be an input for this */
export const getInitials = (name: string): string => {
  if (!name) {
    return "";
  }
  // Remove email domain if present
  const textToUse = name.split("@")[0] ?? name;

  // Split by spaces, hyphens, dots, underscores
  const parts = textToUse
    .trim()
    .split(/[\s._-]+/)
    .filter(Boolean);

  const first = parts[0];
  if (!first) {
    return "";
  }

  if (parts.length >= 2) {
    const last = parts.at(-1)!;
    return (first.charAt(0) + last.charAt(0)).toUpperCase();
  } else if (parts.length === 1 && first.length >= 2) {
    return first.slice(0, 2).toUpperCase();
  } else if (parts.length === 1 && first.length === 1) {
    return first;
  }

  return "";
};
